import { Card, Divider, Grid } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { BankAccountModel } from "../../Api/Models/BankAccountModel";
import BankCard from "../../Components/Cards/BanksCard";
import MDDragable from "../../Components/Dragable";
import DashboardLayout from "../../Components/LayoutContainers/DashboardLayout";
import MDBox from "../../Components/MDBox";
import MDButton from "../../Components/MDButton";
import AppLoading from "../../Components/MDLoading";
import MDTypography from "../../Components/MDTypography";
import DashboardNavbar from "../../Components/Navbars/DashboardNavbar";
import { allBanksAction } from "../../Context/redux/actions";
import { BankAccountDto } from "../../Types/Api/DTO/BankAccountDto";
import ApiResponse from "../../Types/Api/Response";
import { AccountType } from "../../Types/Enums/BankAccountEnum";
import { ErrorToaast, SuccessToaast } from "../../utils/toast/Toast";
import { getKeys } from "../../utils/tools/EnumConverter";

export default function BankPage() {
  const [loading, setLoading] = useState<boolean>(true);
  const [open, setOpen] = useState<boolean>(false);
  const [counter, setCounter] = useState<number>(0);
  const [deleteParams, setDeleteParams] = useState<{
    id: number;
    name: string;
  } | null>(null);
  const dispatch = useDispatch();
  let allParams: BankAccountDto[] = useSelector((state: any) => state.allBanks);
  let BankAccount = new BankAccountModel();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const addItem = async () => {
    navigate("/bankOperation", { replace: true, state: { edit: false } });
  };
  function handleEdit(e: any) {
    let paramsForSend: BankAccountDto = {
      id: e.id,
      BankName: e.bankName,
      StartDate: e.startDate.split("T")[0],
      EndDate: e.endDate.split("T")[0],
      AccountNumber: e.accountNumber,
      ManagerName: e.managerName,
      PhoneNumber: e.phoneNumber,
      Address: e.address,
      Description: e.description,
      IsActive: e.isActive,
      AccountType: e.accountType,
    };
    // console.log(paramsForSend);

    navigate("/bankOperation", {
      replace: true,
      state: { edit: true, data: paramsForSend },
    });
  }
  useEffect(() => {
    BankAccount.getAll()
      .then(async (r) => {
        var response: ApiResponse<BankAccountDto[]> = r.data;
        dispatch(allBanksAction(response.data));
        await setLoading(false);
      })
      .catch((e) => ErrorToaast("مشکل در برقراری ارتباط"));
    return () => {
      dispatch(allBanksAction([]));
    };
  }, []);
  const handleDelete = async () => {
    if (deleteParams) {
      setLoading(true);

      await BankAccount.delete(deleteParams.id)
        .then(() => {
          setCounter((counter) => counter + 1);
          setLoading(false);
          SuccessToaast("با موفقیت حذف شد");
        })
        .catch(() => {
          ErrorToaast("با مشکل مواجه شد ");
        });
    }
    setLoading(false);
    setOpen(false);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar name={"بانک ها"}>
        <MDBox>
          <MDButton variant="outlined" color="secondary" onClick={() => addItem()} fullWidth>
            افزودن
          </MDButton>
        </MDBox>
      </DashboardNavbar>
      <MDDragable
        open={open}
        setOpen={() => setOpen(true)}
        title="حذف پارامتر"
        desciption={`ایا از حذف ${deleteParams?.name} اطمینان دارید ؟`}
        buttons={
          <Grid container justifyContent={"flex-start"}>
            <MDButton onClick={handleDelete}>تایید</MDButton>
            <MDButton autoFocus onClick={() => setOpen(false)}>
              بستن
            </MDButton>
          </Grid>
        }
      />
      <MDBox py={3}>
        <Grid container spacing={3} justifyContent={"center"}>
          {allParams.length < 1 && (
            <Grid container item xs={12} md={11} lg={10}>
              <Card sx={{ width: "100%" }}>
                <MDBox display="flex" justifyContent="center" alignItems="center" p={3}>
                  <MDTypography>هیچ پارامتری ثبت نشده است.</MDTypography>
                </MDBox>
              </Card>
            </Grid>
          )}
          {allParams.length > 0 &&
            allParams.map((e: BankAccountDto | any) => {
              return (
                <Grid key={Math.random()} item xs={12} md={6} lg={6}>
                  <MDBox sx={{ height: "calc(100% - 12px)" }} mb={1.5}>
                    <BankCard
                      editButton={
                        <MDButton variant="gradient" color="secondary" onClick={() => handleEdit(e)} fullWidth>
                          ویرایش
                        </MDButton>
                      }
                      deleteButton={
                        <MDButton
                          variant="gradient"
                          color="error"
                          onClick={() => {
                            setOpen(true);
                            setDeleteParams({ id: e.id, name: e.bankName });
                          }}
                          fullWidth
                        >
                          حذف
                        </MDButton>
                      }
                      color="info"
                      rowNumber={"2"}
                      title={"asd"}
                    >
                      <MDBox mx={1}>
                        <Grid container rowSpacing={1} spacing={2} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                          <Grid item xs={12}>
                            <MDTypography fontSize={14}>نام بانک :{e.bankName}</MDTypography>
                            <Divider />
                          </Grid>
                          <Grid item xs={12}>
                            <MDTypography fontSize={14}>نوع حساب :{t(getKeys(AccountType, e.accountType) ?? "")}</MDTypography>
                            <Divider />
                          </Grid>
                          <Grid item xs={12}>
                            <Grid container>
                              <MDTypography fontSize={14}>تاریخ افتتاح :</MDTypography>
                              <MDTypography fontSize={14}>{e.startDate.split("T")[0].replace(/-/g, "/")}</MDTypography>
                            </Grid>
                            <Divider />
                          </Grid>
                          <Grid item xs={12}>
                            <Grid container>
                              <MDTypography fontSize={14}>تاریخ پایان :</MDTypography>
                              <MDTypography fontSize={14}>{e.endDate.split("T")[0].replace(/-/g, "/")}</MDTypography>
                            </Grid>
                            <Divider />
                          </Grid>
                          <Grid item xs={12}>
                            <MDTypography fontSize={14}>شماره حساب : {e.accountNumber}</MDTypography>
                            <Divider />
                          </Grid>
                          <Grid item xs={12}>
                            <MDTypography fontSize={14}>نام مدیر : {e.managerName}</MDTypography>
                            <Divider />
                          </Grid>
                          <Grid item xs={12}>
                            <MDTypography fontSize={14}>شماره تماس :{e.phoneNumber}</MDTypography>
                            <Divider />
                          </Grid>
                          <Grid item xs={12}>
                            <MDTypography fontSize={14}>آدرس : {e.address}</MDTypography>
                            <Divider />
                          </Grid>
                          <Grid item xs={12}>
                            <MDTypography fontSize={14}>توضیحات : {e.description}</MDTypography>
                          </Grid>
                        </Grid>
                      </MDBox>
                    </BankCard>
                  </MDBox>
                </Grid>
              );
            })}
        </Grid>
      </MDBox>
      <AppLoading show={loading} />
    </DashboardLayout>
  );
}
